import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M23 2a1 1 0 0 0-1-1H12a1 1 0 0 0-.706.293L2.702 9.887a3 3 0 0 0 0 4.23l.002.002 7.17 7.17a3 3 0 0 0 4.244.001l8.589-8.58a1 1 0 0 0 .293-.708zm-2 1v8.587l-8.297 8.29a1 1 0 0 1-1.414 0l-7.168-7.17H4.12a1 1 0 0 1 0-1.41L12.416 3zm-3 4a1 1 0 0 0-1-1h-.01a1 1 0 1 0 0 2H17a1 1 0 0 0 1-1",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }